import React from 'react'
import PropTypes from 'prop-types'

const LiveIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="live">
      <circle id="Ellipse 13" cx="6" cy="6" r="2.25" fill="currentColor" />
    </g>
  </svg>
)

LiveIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

LiveIcon.defaultProps = {
  width: 12,
  height: 12,
}

export default LiveIcon
